import { Theme, ButtonSize, ButtonColor } from './theme';

export function getButtonStyles(
	theme: Theme,
	hasIcon: boolean,
	size: ButtonSize = 'medium',
	buttonColor: ButtonColor = 'primary',
	textOnly: boolean = false,
	outlined: boolean = false
) {
	const { width, height, padding, fontSize } = theme.button.size[size];
	const { iconExtraWidth } = theme.button;
	if (textOnly) {
		const { backgroundColor, color } = theme.textButton.color[buttonColor];
		return {
			padding: '0',
			fontSize: fontSize,
			backgroundColor: backgroundColor,
			color: color,
			border: 'none',
			cursor: 'pointer',
			textDecoration: 'underline'
		};
	} else {
		const { backgroundColor, color } = theme.button.color[buttonColor];
		const baseStyles = {
			width: width,
			height: height,
			padding: padding,
			fontSize: fontSize,
			backgroundColor: backgroundColor,
			cursor: 'pointer',
			color: color,
			border: outlined ? `2px solid ${color}` : 'none'
		};

		return hasIcon ? { ...baseStyles, width: `calc(${width} + ${iconExtraWidth})` } : baseStyles;
	}
}
